import { Locations } from 'app/components/Locations';

const LocationsList = () => {
  return <Locations />;
};

export default LocationsList;
